import Admin from "assets/menu-icons/Admin";

const admin = {
  id: 'admin',
  type: 'group',
  children: [{
    id: 'admin',
    title: 'Администрирование', 
    type: 'item',
    url: '/admin',
    icon: Admin,
    breadcrumbs: false
  }]
}

export default admin;
